module.exports = __webpack_public_path__ + "img/background-header.67d8398.png";